// extracted by mini-css-extract-plugin
export var body = "styles-module--body--cTMaU";
export var component = "styles-module--component--eWeNl";
export var title = "styles-module--title--Nuw0A";